import * as React from 'react';

import { cn } from './lib/utils';

type TextareaProps = React.ComponentProps<'textarea'> & {
  error?: string;
};

function Textarea({ className, error, ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-sm border bg-transparent px-3 py-2 md:text-base transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50  placeholder:text-xs md:placeholder:text-base text-sm',
        className,
        error && 'border-destructive',
      )}
      {...props}
    />
  );
}

export { Textarea };
